/**
 * Дерево модулей ERP: сайдбар, вкладки шапки, маршруты заглушек. Описание полей
 * и полная таблица — docs/ERP_IA.md (держать в синхроне с этим файлом).
 * item: path, label, view (есть только у рабочих экранов; иначе views/stub.js),
 *       wave (волна заглушки, по умолчанию «В2»), count (ключ из sidebar-counts.js), need (код права).
 * module: badge { key, tone: 'attention' | 'new' }, nearest (ближайший рабочий экран),
 *         home (куда ведёт клик по модулю, если в нём ещё не были; по умолчанию первый пункт).
 */
export const MODULES = [
  {
    key: 'desk', label: 'Рабочий стол',
    badge: { key: 'desk', tone: 'attention' },
    nearest: { path: '/my-day', label: 'Мой день' },
    items: [
      { path: '/desk/decisions', label: 'Требует решения', count: 'decisions', tone: 'attention', view: 'desk.js' },
      { path: '/desk/my-tasks',  label: 'Мои задания', view: 'desk.js' },
      { path: '/desk/signals',   label: 'Сигналы', view: 'desk.js' },
    ],
  },
  {
    key: 'sales', label: 'Продажи',
    badge: { key: 'sales', tone: 'new' },
    nearest: { path: '/pipeline', label: 'Pipeline' },
    items: [
      { path: '/tenders',          label: 'Аукционы', count: 'tenders', tone: 'new', view: 'tenders.js' },
      { path: '/sales/customers',  label: 'Заказчики и события' },
      { path: '/sales/quotes',     label: 'КП и заявки' },
      { path: '/sales/contracts',  label: 'Договоры' },
      { path: '/sales/acts',       label: 'Акты и счета' },
      { path: '/sales/price-list', label: 'Прайс услуг' },
      { path: '/sales/court',      label: 'Судебные решения' },
    ],
  },
  {
    key: 'projects', label: 'Проекты',
    nearest: { path: '/gantt', label: 'Gantt' },
    items: [
      { path: '/projects/sheets',      label: 'Исполнительные листы', view: 'sheets.js' },
      { path: '/projects/registry',    label: 'Книга регистрации' },
      { path: '/projects/work-orders', label: 'Задания на работу' },
      { path: '/projects/production',  label: 'Производство проектной продукции' },
      { path: '/projects/gip',         label: 'Сектор ГИП' },
      { path: '/projects/norm-control', label: 'Н.контроль', view: 'normcontrol.js', need: 'norm.read', count: 'norm_need_text', tone: 'attention' },
      { path: '/projects/expertise',   label: 'Экспертиза', view: 'expertise.js' },
      { path: '/projects/office',      label: 'Делопроизводство' },
      { path: '/projects/minutes',     label: 'Протоколы совещаний' },
      { path: '/projects/reports',     label: 'Отчёты' },
    ],
  },
  {
    key: 'ccpm', label: 'CCPM',
    nearest: { path: '/gantt', label: 'Gantt' },
    home: '/gantt',
    items: [
      { path: '/',                   label: 'Dashboard',   view: 'dashboard.js', alias: '/dashboard' },
      { path: '/my-day',             label: 'Мой день',    view: 'my-day.js' },
      { path: '/gantt',              label: 'Gantt',       view: 'gantt.js' },
      { path: '/resources',          label: 'Ресурсы',     view: 'resources.js' },
      { path: '/volume',             label: 'Объём',       view: 'volume.js' },
      { path: '/fever',              label: 'Fever',       view: 'fever.js' },
      { path: '/pipeline',           label: 'Pipeline',    view: 'pipeline.js' },
      { path: '/contractor-updates', label: 'Подрядчики',  view: 'contractor-updates.js' },
      { path: '/calibration',        label: 'Калибровка',  view: 'calibration.js' },
    ],
  },
  {
    key: 'people', label: 'Люди',
    nearest: { path: '/resources', label: 'Ресурсы' },
    items: [
      { path: '/people/employees',       label: 'Сотрудники' },
      { path: '/people/timesheet',       label: 'Время заданий и табель' },
      { path: '/people/output',          label: 'Выработка' },
      { path: '/people/requests',        label: 'Заявления' },
      { path: '/people/advance-reports', label: 'Авансовые отчёты' },
      { path: '/people/trips',           label: 'Командировки' },
      { path: '/people/freelancers',     label: 'Договора фрилансеров' },
      { path: '/people/payroll',         label: 'Расчёт ЗП', wave: 'В3' },
    ],
  },
  {
    key: 'finance', label: 'Финансы',
    nearest: { path: '/volume', label: 'Объём' },
    items: [
      { path: '/finance/fund-requests',   label: 'Заявки на средства', wave: 'В3' },
      { path: '/finance/directives',      label: 'Директивы', wave: 'В3' },
      { path: '/finance/purchase-orders', label: 'Заказы на приобретение', wave: 'В3' },
      { path: '/finance/planning',        label: 'Финпланирование', wave: 'В3' },
      { path: '/finance/pnl',             label: 'Расходы и доходы', wave: 'В3' },
      { path: '/finance/owner-loans',     label: 'Займы собственников', wave: 'В3' },
      { path: '/finance/margin',          label: 'Маржинальность', wave: 'В3' },
      { path: '/finance/cash-flow',       label: 'ДДС', wave: 'В3' },
    ],
  },
  {
    key: 'director', label: 'Директор',
    nearest: { path: '/', label: 'Dashboard' },
    items: [
      { path: '/director/tender-funnel',  label: 'Воронка аукционов', view: 'tender-funnel.js' },
      { path: '/director/channels',       label: 'Каналы продаж' },
      { path: '/director/project-margin', label: 'Маржинальность проектов', wave: 'В3' },
      { path: '/director/output',         label: 'Выработка' },
      { path: '/director/plan-fact',      label: 'План/факт сроков' },
      { path: '/director/fever',          label: 'Fever-сводка' },
    ],
  },
  {
    key: 'admin', label: 'Администрирование',
    nearest: { path: '/audit', label: 'Аудит' },
    items: [
      { path: '/admin',               label: 'Админ',       view: 'admin.js', need: 'user.read' },
      { path: '/audit',               label: 'Аудит',       view: 'audit.js' },
      { path: '/admin/roles',         label: 'Роли' },
      { path: '/admin/counterparties', label: 'Контрагенты', view: 'counterparties.js', need: 'ref.read' },
      { path: '/admin/organizations', label: 'Организации' },
      { path: '/admin/integrations',  label: 'Интеграции' },
    ],
  },
];

/** { module, item } для базового пути (см. getBasePath в router.js) или null. */
export function findItem(basePath) {
  for (const module of MODULES) {
    const item = module.items.find(it => it.path === basePath);
    if (item) return { module, item };
  }
  return null;
}

/** Маршруты, которые обслуживает views/stub.js (все пункты без view). */
export function stubPaths() {
  return MODULES.flatMap(m => m.items.filter(it => !it.view).map(it => it.path));
}

/** Подпункты модуля с учётом прав (canDo из auth.js передаётся снаружи). */
export function visibleItems(module, canDo) {
  return module.items.filter(it => !it.need || canDo(it.need));
}

/**
 * Куда ведёт клик по названию модуля в сайдбаре (UI-2): последний посещённый пункт модуля,
 * если он ещё виден по правам, иначе home модуля, иначе первый видимый пункт.
 */
export function moduleTarget(module, canDo, lastPath) {
  const items = visibleItems(module, canDo);
  if (lastPath && items.some(it => it.path === lastPath)) return lastPath;
  if (module.home && items.some(it => it.path === module.home)) return module.home;
  return items[0]?.path ?? null;
}
